import './orderCard.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { COMPLETED_ORDER_STATUSES } from '@constants/order';
import { stripMyOmePrefix } from '@pages/order/utils/productDisplayName';

import { getRequisitionStatus, getRequisitionStatusKey } from '../../../helpers/requisition';
import { formatDate } from '../../../utils/helpers';
import DataDisplayCell from '../../DataDisplayCell/dataDisplayCell';

function OrderCard({ testRequest, onClick }) {
  const getDisplayStatus = getRequisitionStatus(testRequest) || 'Order Placed';
  const statusKey = getRequisitionStatusKey(testRequest);
  const isCompleted = statusKey ? COMPLETED_ORDER_STATUSES.includes(statusKey) : false;
  const productNames = (testRequest.orders || [])
    .map(order => order.product_name)
    .filter(Boolean)
    .map(stripMyOmePrefix);

  return (
    <div className='order_card_wrapper' onClick={onClick || undefined} data-testid='orderCardWrapper'>
      <div className='order_top_half'>
        <div className='dna_icon_wrapper'>
          <FontAwesomeIcon
            icon={'fa-duotone fa-dna'}
            style={{
              '--fa-primary-color': '#36cbd9',
              '--fa-secondary-color': '#003595',
              '--fa-secondary-opacity': '1',
              fontSize: '28px',
            }}
          />
        </div>
        <div className='order_card_header'>
          <div className='order_header_metadata'>
            <div className='order_requisition_id'>{testRequest.requisition_id}</div>
            <div className='order_header_date' data-testid='orderDate'>
              Ordered {formatDate(testRequest.submitted_at)}
            </div>
          </div>
          <div data-testid='orderStatus' className={isCompleted ? 'order_status_cell_success' : 'order_status_cell'}>
            {getDisplayStatus}
          </div>
        </div>
      </div>
      <div className='order_bottom_half'>
        <DataDisplayCell
          dataLabel='Report Type'
          multiline={true}
          multiLines={productNames}
          dataValueTestid='reportType'
        />
      </div>
    </div>
  );
}

export default OrderCard;
